module.exports = __webpack_public_path__ + "static/media/smallIsland.4438fe1e.png";